var _excluded = ["iconType", "icon", "className", "uiSchema", "registry"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx } from "react/jsx-runtime";
import { TranslatableString } from '@rjsf/utils';
export default function IconButton(props) {
  var _props$iconType = props.iconType,
      iconType = _props$iconType === void 0 ? 'default' : _props$iconType,
      icon = props.icon,
      className = props.className,
      uiSchema = props.uiSchema,
      registry = props.registry,
      otherProps = _objectWithoutProperties(props, _excluded);

  return _jsx("button", _objectSpread(_objectSpread({
    type: 'button',
    className: "btn btn-".concat(iconType, " ").concat(className)
  }, otherProps), {}, {
    children: _jsx("i", {
      className: "glyphicon glyphicon-".concat(icon)
    })
  }));
}
export function CopyButton(props) {
  var translateString = props.registry.translateString;
  return _jsx(IconButton, _objectSpread(_objectSpread({
    title: translateString(TranslatableString.CopyButton),
    className: 'array-item-copy'
  }, props), {}, {
    icon: 'copy'
  }));
}
export function MoveDownButton(props) {
  var translateString = props.registry.translateString;
  return _jsx(IconButton, _objectSpread(_objectSpread({
    title: translateString(TranslatableString.MoveDownButton),
    className: 'array-item-move-down'
  }, props), {}, {
    icon: 'arrow-down'
  }));
}
export function MoveUpButton(props) {
  var translateString = props.registry.translateString;
  return _jsx(IconButton, _objectSpread(_objectSpread({
    title: translateString(TranslatableString.MoveUpButton),
    className: 'array-item-move-up'
  }, props), {}, {
    icon: 'arrow-up'
  }));
}
export function RemoveButton(props) {
  var translateString = props.registry.translateString;
  return _jsx(IconButton, _objectSpread(_objectSpread({
    title: translateString(TranslatableString.RemoveButton),
    className: 'array-item-remove'
  }, props), {}, {
    iconType: 'danger',
    icon: 'remove'
  }));
}